import { useEffect } from "react";

const DEFAULT_IMAGE = "/og-image.png";
const DEFAULT_TITLE = "HomecareMatches - Home Care Services & Senior Care Matching";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
}

/**
 * Per-route SEO + social preview (Open Graph + Twitter card).
 * Renders nothing; updates <head> on mount / prop change.
 * `ogDescription` lets a page use a different description for social cards.
 */
export default function Seo({ title, description, ogDescription, twitterDescription, keywords, path = "", image = DEFAULT_IMAGE }) {
  useEffect(() => {
    const fullTitle = title ? `${title} · HomecareMatches` : DEFAULT_TITLE;
    document.title = fullTitle;
    const origin = typeof window !== "undefined" ? window.location.origin : "";
    const url = `${origin}${path || (typeof window !== "undefined" ? window.location.pathname : "")}`;
    const absImage = image.startsWith("http") ? image : `${origin}${image}`;
    const ogDesc = ogDescription || description;
    const twDesc = twitterDescription || ogDescription || description;

    upsertMeta("name", "description", description);
    upsertMeta("name", "keywords", keywords);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:site_name", "HomecareMatches");
    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", ogDesc);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", absImage);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", twDesc);
    upsertMeta("name", "twitter:image", absImage);

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement("link"); link.setAttribute("rel", "canonical"); document.head.appendChild(link); }
    link.setAttribute("href", url);
  }, [title, description, ogDescription, twitterDescription, keywords, path, image]);
  return null;
}
